import type { ReferenceFormAccessor } from 'types'

import { viewOnlyFields } from '../constants/formViewOnlyFields'

export const getViewOnlyFields = (omitFields: ReferenceFormAccessor | ReferenceFormAccessor[]) =>
  viewOnlyFields.filter((field) => (Array.isArray(omitFields) ? !omitFields.includes(field) : omitFields !== field))
